import { Skeleton } from '@/components/ui/skeleton'

export const ConnectionListSkeleton = () => (
	<div className="w-full space-y-4">
		<div className="flex items-center justify-between">
			<Skeleton className="h-5 w-24" />
			<Skeleton className="h-8 w-32" />
		</div>
		<Skeleton className="h-16 w-full rounded-lg" />
		<Skeleton className="h-16 w-full rounded-lg" />
	</div>
)
